<template>
  <div>
    <BackButton class="u-margin-bottom-small"></BackButton>
    <SuggestionForm @submit="createSuggestion($event)" :loadingSave="loadingSave"></SuggestionForm>
  </div>
</template>

<script>
import BackButton from '@/components/buttons/BackButton';
import SuggestionForm from '@/pages/Suggestions/SuggestionForm';
import DashboardElementController from '@/controllers/DashboardElement/DashboardElementController';
import QuestionController from '@/controllers/Question/QuestionController';
export default {
  name: 'CreateSuggestion',
  components: { SuggestionForm, BackButton },
  data() {
    return {
      loadingSave: false,
    };
  },
  methods: {
    async createSuggestion(form) {
      this.loadingSave = true;
      try {
        let dashElement = await DashboardElementController.store(form);
        form.dashboard_element_id = dashElement.id;
        form.suggestion = 1;
        if (!form.question_text) form.question_text = form.headline;
        await QuestionController.store(form);
        await this.$router.push({ name: 'Suggestions' });
        this.$gtag.event('Suggestion Created', { method: 'Google' });
        this.$notify({
          type: 'success',
          title: 'Successfully created!',
        });
      } catch (error) {
        this.$gtag.exception({
          description: 'Error By Creating Suggestion',
          fatal: false,
        });
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.loadingSave = false;
    },
  },
};
</script>

<style scoped></style>
